// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"315":"7109caf4","638":"2181a064"}[chunkId] + ".chunk.js";
};